<boi-validation-error-generic [validationErrors]="validationErrors" [propertyNames]="validationPropertyNames">
</boi-validation-error-generic>
<kendo-textbox-container class="form-element">
  <div [ngClass]="cssClasses" class="field-container">
    <div class="field-label" [boiRequiredFormField]="required ? labelName : undefined">
      <label [for]="controlId ? controlId : labelName" [innerHtml]="labelName ? (labelName | localizeLabel) : ''"></label>
      <boi-tooltip [tooltipName]="tooltipName ? tooltipName : (labelName ? (labelName | localizeLabel) : '')"></boi-tooltip>
    </div>
    <div class="field-input">
      <label class="radio-input">
        <input type="radio" [id]="controlId ? controlId : labelName" class="form-radio-button"
          [name]="controlId ? controlId : labelName" [disabled]="isFieldDisabled" [(ngModel)]="value"
          [value]="radioValue">
        <span class="label" [innerHtml]="radioLabel"></span>
      </label>
      <ng-content></ng-content>
    </div>
  </div>
</kendo-textbox-container>
